import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import OwlCarousel from 'react-owl-carousel';
import MEDIA_URL from "../../contants";
const PartnerList = (props) => {

  // const [games, setGames] = useState([]);

  // useEffect(() => {
  //   const partnerImages = [
  //     { title: "Evolution", img: "evolution.png" },
  //     { title: "Zeus", img: "ZeusPlay.png" },
  //     { title: "Gaming", img: "" },
  //     { title: "Play", img: "play.png" },
  //     { title: "7UpDown", img: "7up7down.gif" },
  //     { title: "32-cards", img: "32cards.gif" },
  //     { title: "Worli-Matka", img: "worlimatka.gif" },
  //     { title: "BollywoodCasino", img: "bollywoodcasino.gif" },
  //     { title: "BlackJack", img: "blackjackbrusurest.gif" },
  //     { title: "Baccarot", img: "bacacrtdeluxe.gif" },
  //     { title: "Roulette", img: "roulettelobby.gif" },
  //   ];
  //   setGames(partnerImages);
  // }); 

  const partnerImages = [
    {
      title: "Evolution",
      img: "evolution.png",
    },
    {
      title: "Playson",
      img: "playson.png",
    },
    {
      title: "Amigo",
      img: "atent.png",
    },
    {
      title: "Play",
      img: "play.png",
    },
    {
      title: "Belatra",
      img: "belatra.png",
    },
    {
      title: "Nolimit",
      img: "nowmit.png",
    },
    {
      title: "Oaks",
      img: "oaks.png",
    },
    {
      title: "spadegame",
      img: "spadegame.png",
    },
    {
      title: "Netent",
      img: "netent.png",
    },
    {
      title: "Vivo",
      img: "vivo.png",
    },
  ];

  return (
    <>
      {
      }
      <OwlCarousel
        className='portal-casino owl-theme'
        loop
        margin={10}
        autoplay={true}
        dots={false}
        responsive={{
          0: { // For mobile devices
            items: 3
          },
          768: { // For tablets
            items: 5
          },
          1000: { // For desktops and larger screens
            items: 7.5
          }
        }}
      >
        {
          partnerImages.map((data, idx) => (
            <div key={idx}>
              <img
                alt={data.title}
                title={data.title}
                src={`${MEDIA_URL}/web-images/${data.img}`}
              />
            </div>
          ))
        }
      </OwlCarousel>

    </>
  );
};

export default withRouter(PartnerList);
